import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "swiper/swiper-bundle.css";
import "simplebar-react/dist/simplebar.min.css";
import App from "./App.tsx";
import { AppWrapper } from "./components/common/PageMeta.tsx";
import { ThemeProvider } from "./context/ThemeContext.tsx";
import { loadExchangeRates } from "./utils/currency.ts";
// import Footer from "./components/footer/Footer.tsx";

// Fetch live FX rates once at boot (non-blocking). Until they arrive, amounts
// are displayed in the store's own currency - which is already correct.
void loadExchangeRates();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider shop="shopify">
      <AppWrapper>
        <App />
        {/* <Footer/> */}
      </AppWrapper>
    </ThemeProvider>
  </StrictMode>
);
